import { getPlatformId as _ } from "../../../stores/config.js";
import { getServiceUrl as i } from "../../compass/compass-services.js";
import { SERVICE as S } from "../../compass/services.js";
import { logout as l } from "../logout.js";
const u = [
  "ERROR_ACCESS_FORBIDDEN_LICENSE_EXPIRED",
  "ERROR_ACCESS_FORBIDDEN_LICENSE_FULLY_CONSUMED",
  "ERROR_LICENSING_EXTENSION_KO",
  "ERROR_ACCESS_NO_LICENSE",
  "ERROR_ACCESS_FORBIDDEN_NO_LICENSE"
], A = "GLOBAL_ERROR_EVENT", d = "invalid_grant", I = 400;
function U(t, e) {
  return async (r, s, n) => {
    if (n.status !== I)
      return;
    const o = await n.json();
    if (o.error !== d)
      return;
    const { access_token: E } = await e(o.x3ds_auth_url, {
      handlePassportExpiredError: s.handlePassportExpiredError,
      headers: { "X-Request-Id": "" }
    }).json(), a = new URL(r.url).searchParams;
    return a.set("ticket", E), s.json && delete s.body, t(r.url, { ...s, searchParams: a });
  };
}
const O = "invalid_client", C = 401, L = async (t, e, r) => {
  e.handlePassportExpiredError === !1 || r.status !== C || (await r.json()).error !== O || l();
}, c = 403, p = "ERROR_ACCESS_FORBIDDEN_NOT_ACTIVE";
async function R(t) {
  var s, n;
  let e, r;
  try {
    const { response: o } = t, a = ((s = o.headers.get("content-type")) == null ? void 0 : s.includes("application/json")) ? await o.clone().json() : null;
    e = (n = t.response) == null ? void 0 : n.status, r = a == null ? void 0 : a.errorcode;
  } catch {
  }
  return { errorCode: r, errorStatus: e };
}
const h = async (t) => {
  const { errorCode: e, errorStatus: r } = await R(t);
  if (r !== c || e !== p)
    return t;
  const s = window.btoa(window.location.href).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, ""), n = _(), E = `${await i(S.COMPASS, n)}/resources/AppsMngtSynchro/api/v1?service=3DSWYM&url=${s}&platform=${n}`;
  return window.location.href = E, t;
}, w = async (t) => {
  const { errorCode: e, errorStatus: r } = await R(t);
  return r !== c || !e || !u.includes(e) || window.postMessage({
    event: A,
    payload: { code: e, status: r }
  }), t;
};
export {
  A as GLOBAL_ERROR_EVENT,
  u as GLOBAL_ERROR_LIST_403,
  h as handleInactiveUser,
  w as handleLicenseError,
  L as passportAuth,
  U as servicesAuth
};
